import { Routes } from '@angular/router';
import { modalGuard } from '@core/guards/modal.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		loadComponent: () =>
			import('./components/marketplace/marketplace.component').then(
				(m) => m.MarketplaceComponent
			),
		canDeactivate: [modalGuard]
	}
];
